export const StoreState = {
    results:'results',
    id: 'id'
}

export const state = {
    [StoreState.results]:[],
    [StoreState.id]: null
}
